import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { BloodworkAnalysis, PanelMarker, FurtherConsiderations, Section } from '../../models';
import { AnemiaStatus } from './bloodwork-anemia-status';
import { Footer } from '../../Footer';
import { TabsComponent } from '../tabs-component';
import { WBCEvaluation } from './bloodwork-wbc-evaluation';
import { GlucoseRegulationInsights } from './glucose-regulation-insights';
import { BloodworkEntryStore } from '../../stores/bloodwork-entry-store';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Props = {
  section: Section;
  panelTitle: string;
  bloodworkAnalysis: BloodworkAnalysis;
  panelMarkers: PanelMarker[];
  furtherConsiderations: FurtherConsiderations;
  evalSmall: number;
  refSmall: number;
  evalLarge: number;
  refLarge: number;
  infoLink: string;
  bloodworkEntryStore: BloodworkEntryStore;
  enabledSupplementBrands: string[];
  collapsed: boolean;
  onToggle: () => void;
};

export class BloodworkTestAnalysisSection extends React.Component<Props, {}> {

  evaluation = () => {
    const { bloodworkAnalysis, section, evalSmall, evalLarge } = this.props;
    if (section === Section.RBC) {
      return (
        <Col xs={evalSmall} lg={evalLarge}>
          <AnemiaStatus bloodworkAnalysis={bloodworkAnalysis} />
        </Col>  
      );
    } else if (section === Section.WBC && bloodworkAnalysis.wbc.hasValue()) {
      return (
        <Col xs={evalSmall} lg={evalLarge}>
          <WBCEvaluation bloodworkAnalysis={bloodworkAnalysis} />
        </Col>
      );
    } else if (section === Section.GLUCOSE && process.env.REACT_APP_ENV !== 'prod') {
      return (
        <Col xs={evalSmall} lg={evalLarge}>
          <GlucoseRegulationInsights bloodworkAnalysis={bloodworkAnalysis} />
        </Col>
      );
    } else {
      return null;
    }
  }

  analysis = () => {
    const { section, bloodworkAnalysis, panelMarkers, furtherConsiderations,
      refSmall, refLarge, bloodworkEntryStore, infoLink, enabledSupplementBrands } = this.props;
      return (
        <Col xs={refSmall} lg={refLarge}>
          <TabsComponent
            section={section}
            panelMarkers={panelMarkers}
            bloodworkAnalysis={bloodworkAnalysis} 
            furtherConsiderations={furtherConsiderations}
            bloodworkEntryStore={bloodworkEntryStore}
            infoLink={infoLink}
            enabledSupplementBrands={enabledSupplementBrands}
          />
        </Col>
      );
  }

  render() {
    const { panelTitle, panelMarkers, collapsed, onToggle } = this.props;
    const chevron = collapsed ? 'chevron-down' : 'chevron-up';
    return (
      <>
      { panelMarkers.length > 0 ?
        <Card>
          <Card.Header onClick={onToggle} style={{ cursor: 'pointer' }}>
            <FontAwesomeIcon icon={chevron} />&nbsp;&nbsp;{panelTitle} *
          </Card.Header>
          {!collapsed && (
            <>
              <Card.Body>
                <Row>
                  {this.evaluation()}
                  {this.analysis()}
                </Row>
              </Card.Body>
              <Card.Footer>
                <Footer />
              </Card.Footer>
            </>
          )}
        </Card>
        : null
      }
      </>
    );
  }
}
